import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment'
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-menu-negar',
  templateUrl: './menu-negar.page.html',
  styleUrls: ['./menu-negar.page.scss'],
})

export class MenuNegarPage implements OnInit {

  constructor(public api: ApiService/*  public calc:CalculadoraPage */) { }

  ngOnInit() {}

  async botonNegar() {
    this.api.popoverController.dismiss(); 
    await this.negar();
    this.api.setEstudioCalc(this.api.motivoRechazo);
  }

  async negar(){
    let usuarioOk1 = this.api.user.Usuario.trim();
    await this.api.presentLoading('Cargando');
    const req = new Promise((resolve, reject) => {
      let body = { cedula: this.api.arrCalc.Cedula, numsol: this.api.arrCalc.NumSol, usuario: usuarioOk1, motivo: this.api.motivoRechazo };
      this.api.http.post(environment.urlApi + 'negarrrhhnew', body).subscribe((res: any) => {
        this.api.endLoading();
        resolve(1);
      });
    })
    const respuesta = await req;
    return respuesta;
  }
}